export enum ProjectSimulatorType {
  NEW = 'NEW',
  RENOVATION = 'RENOVATION'
}
